import {EquipmentType} from '@hconnect/common/types'
import {ReactNode} from 'react'

import {CementMillIcon} from './icons/CementMillIcon'
import {KilnRotaryIcon} from './icons/KilnRotaryIcon'

const KilnIcon = () => <KilnRotaryIcon sx={{marginRight: 1}} />

const MillIcon = () => <CementMillIcon sx={{transform: 'translateY(5px)', width: 24, height: 24}} />

export const EQUIPMENT_TYPE_ICON_MAP: Record<EquipmentType, ReactNode> = {
  [EquipmentType.KILN]: <KilnIcon />,
  [EquipmentType.BALL_MILL]: <MillIcon />,
  [EquipmentType.DOSING_EQUIPMENT]: <MillIcon />,
  [EquipmentType.VERTICAL_MILL]: <MillIcon />,
  [EquipmentType.ROLLER_PRESS]: <MillIcon />,
  [EquipmentType.OTHER]: <MillIcon />
}
